<template>
    <div class="message-box">
        <notification v-for="(notification, index) in notifications" :notification="notification" :type="notification.type" :interval="notification.interval" v-bind:key="index" :index="index"/>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import Notification from "./Notification";

    export default {
        name: 'notifications-component',
        components: {Notification},
        data() {

            return {
                show: false
            }
        },
        computed: {
            ...mapState({
                notifications: state => state.notifications,
            }),
        },
        methods: {
            closePopup() {
                //console.log('close')
            }
        }
    }
</script>

<style scoped>

</style>
